import request from '@/plugins/axios'

// 查询用户分页
export function userPage(data) {
    return request({
        url: '/sys/user/page',
        method: 'post',
        data: data
    })
}

// 查询用户列表
export function userList(data) {
    return request({
        url: '/sys/user/list',
        method: 'post',
        data: data
    })
}

// 查询用户详细
export function userDetail(id) {
    const data = {
        id : id
    };
    return request({
        url: '/sys/user/detail',
        method: 'post',
        data
    })
}

// 查询用户详细
export function userInfo(id) {
    const data = {
        id : id
    };
    return request({
        url: '/sys/user/info',
        method: 'post',
        data
    })
}


// 新增用户
export function userAdd(data) {
    return request({
        url: '/sys/user/add',
        method: 'post',
        data: data
    })
}

// 修改用户
export function userUpdate(data) {
    return request({
        url: '/sys/user/update',
        method: 'post',
        data: data
    })
}

// 删除用户
export function userDelete(id) {
    const data = {
        id: id
    };
    return request({
        url: '/sys/user/delete/',
        method: 'post',
        data
    })
}

// 改变用户状态
export function changeUserAbled(data) {
    return request({
        url: '/sys/user/changeUserAbled',
        method: 'post',
        data
    })
}

// 查询用户详细
export function userCurrentInfo() {
    return request({
        url: '/getInfo',
        method: 'get',
    })
}


// 当前用户修改信息
export function userUpdateCurrentInfo(data) {
    return request({
        url: '/sys/user/updateCurrentInfo',
        method: 'post',
        data
    })
}

// 当前用户修改密码
export function userChangeCurrentPwd(data) {
    return request({
        url: '/sys/user/updatePassword',
        method: 'post',
        data
    })
}

export function userUpdateAvatar(data) {
    return request({
        url: '/sys/user/updateAvatar',
        method: 'post',
        data
    })
}

